import { useQuery } from '@apollo/client'
import { formatAppsyncErrors } from '../../../appsync/utils'
import { restrictionsQuery } from '../../../appsync/graphql/common'

const useGetRestrictionsQuery = ({ stateCd, educationPeriod, skipConditions = false }) => {
  const {
    loading,
    error: rawError = null,
    data: rawData = {},
  } = useQuery(restrictionsQuery, {
    variables: { getRestrictions: true, stateCd, educationPeriod },
    skip: !stateCd || !educationPeriod || skipConditions, // Adjust this based on your requirements
  })

  const data = rawData?.getRestrictions?.restrictions ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { data, loading, error }
}

export default useGetRestrictionsQuery
